<style lang="sass">
</style>

<template>
    <div :data-src="src"></div>
</template>

<script>
import { attr } from 'gaspard'
import SVGInjector from 'svg-injector'

export default {
    props: ['src', 'color'],
    data () {
        return {}
    },
    ready () {
        this.init()
    },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            SVGInjector(this.$el, {
                each (el) {
                    if (typeof el !== 'object') {
                        return
                    }
                    attr(el, 'aria-hidden', true)
                }
            })
        }
    }
}
</script>
